import rolesService from './rolesService'

export default rolesService



// WEBPACK FOOTER //
// ../src/services/rolesService/index.js